import { Injectable } from '@angular/core';
import { DigitalCVModel } from '@digilize/shared/definitions/src';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { CvService } from './cv.service';

@Injectable({
  providedIn: 'root',
})
export class SharedAccountDataService {
  private readonly cvSubject = new BehaviorSubject<DigitalCVModel>(null);
  readonly cv$ = this.cvSubject.asObservable().pipe(filter((cv) => cv !== null));

  constructor(private cvService: CvService) {}

  loadCv(): Observable<DigitalCVModel> {
    return this.cvService.getCV().pipe(tap((cv) => this.cvSubject.next(cv)));
  }

  setCv(cv: DigitalCVModel): void {
    this.cvSubject.next(cv);
  }

  updateCv(param: keyof DigitalCVModel, value: DigitalCVModel[keyof DigitalCVModel]): void {
    const currentCv = this.cvSubject.getValue();
    if (currentCv) {
      this.cvSubject.next({ ...currentCv, [param]: value });
    }
  }

  updateFullCv(cv: DigitalCVModel): void {
    this.cvSubject.next(cv);
  }
}
